<draggable v-model="listItemsCurrent" tag="ul" group="listItemsCurrent" @drop="onDrop">
    <template #item="{ element: val }">
        <li>{{ val }}</li>
    </template>
</draggable>